module.exports = __webpack_public_path__ + "img/Pro Gamer eSport Logo.jpg";